module.exports = __webpack_public_path__ + "static/img/miaosha.98b62e88.png";